/**
 * 权限节点（只读）— GET /api/admin/nodes
 */
import { useQuery } from '@tanstack/react-query';
import { Table } from 'antd';
import { api } from '../../api/client';

interface NodeRow {
  id: number;
  key: string;
  description: string;
  group: string | null;
}

export function NodesPage() {
  const { data = [], isFetching } = useQuery({
    queryKey: ['admin', 'nodes'],
    queryFn: () => api.get<NodeRow[]>('/api/admin/nodes'),
  });

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 70 },
    { title: '节点键', dataIndex: 'key', width: 220 },
    { title: '说明', dataIndex: 'description' },
    { title: '分组', dataIndex: 'group', width: 120, render: (v: string | null) => v ?? '—' },
  ];

  return (
    <Table<NodeRow>
      size="small"
      bordered
      rowKey="id"
      loading={isFetching}
      dataSource={data}
      columns={columns}
      pagination={false}
    />
  );
}
